export default __webpack_public_path__ + "images/38aee18e86f51b62ad5e548bd745488d.svg";